import { createAction } from '@reduxjs/toolkit';

export const REMOVE_SESSION_ACTION_TYPE = 'saga/removeSession';
export const removeSessionAction = createAction(REMOVE_SESSION_ACTION_TYPE);
